'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function Controller($filter, $window, DiscountComponent, PageHeading, Toast) {
	'ngInject';

	var vm = this;
	vm.getDiscounts = DiscountComponent.getDiscounts;
	vm.deleteDiscount = deleteDiscount;

	activate();

	function activate() {
		var heading = $filter('translate')('SIDEBAR.DISCOUNTS');
		var title = 'BTMS | ' + $filter('translate')('SIDEBAR.DISCOUNTS');

		PageHeading.setPageHeading(heading, title);
	}

	function deleteDiscount(id) {
		if ($window.confirm($filter('translate')('CONFIRM.DELETE'))) {
			DiscountComponent.deleteDiscount(id).then(function (res) {
				if (res.data.errors) {
					Toast.responseError(res.data.errors);
				} else {
					Toast.success($filter('translate')('SUCCESS.DELETE_DISCOUNT'));
					DiscountComponent.fetchDiscounts();
				}
			});
		}
	}
}

exports['default'] = Controller;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/discounts/list/list.controller.js
 **/